jQuery($ => {
    // custom select
    var x, i, j, selElmnt, a, b, c;
    x = document.getElementsByClassName("e-select");
    for (i = 0; i < x.length; i++) {
        selElmnt = x[i].getElementsByTagName("select")[0];
        a = document.createElement("DIV");
        a.setAttribute("class", "e-select__selected");
        a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
        x[i].appendChild(a);
        b = document.createElement("DIV");
        b.setAttribute("class", "e-select__items hidden")
        for (j = 1; j < selElmnt.length; j++) {
            c = document.createElement("DIV");
            c.innerHTML = selElmnt.options[j].innerHTML;
            var elementValue = selElmnt.options[j].getAttribute('value');
            var elementSlug = selElmnt.options[j].getAttribute('data-slug');
            c.setAttribute("value", elementValue);
            c.setAttribute("data-slug", elementSlug);
            c.setAttribute("data-tax", "joboffer-category");
            c.addEventListener("click", function(e) {
                var y, i, k, s, h;
                s = this.parentNode.parentNode.getElementsByTagName("select")[0];
                h = this.parentNode.previousSibling;
                for (i = 0; i < s.length; i++) {
                    if (s.options[i].innerHTML == this.innerHTML) {
                        s.selectedIndex = i;
                        h.innerHTML = this.innerHTML;
                        y = this.parentNode.getElementsByClassName("current");
                        for (k = 0; k < y.length; k++) {
                            y[k].removeAttribute("class");
                        }
                        this.setAttribute("class", "current");
                        $(".e-select")
                            .children("select")
                            .change();
                        break;
                    }
                }
                h.click();
            });
            b.appendChild(c);
        }
        x[i].appendChild(b);
        a.addEventListener("click", function(e) {
            e.stopPropagation();
            closeAllSelect(this);
            this.nextSibling.classList.toggle("hidden");
            this.classList.toggle("active");
        });
    }

    function closeAllSelect(elmnt) {
        var x,
            y,
            i,
            arrNo = [];
        x = document.getElementsByClassName("e-select__items");
        y = document.getElementsByClassName("e-select__selected");
        for (i = 0; i < y.length; i++) {
            if (elmnt == y[i]) {
                arrNo.push(i);
            } else {
                y[i].classList.remove("active");
            }
        }
        for (i = 0; i < x.length; i++) {
            if (arrNo.indexOf(i)) {
                x[i].classList.add("hidden");
            }
        }
    }

    document.addEventListener("click", closeAllSelect);
});
